import { Order } from "@/entities/order/order";
import { ICalculatePriceRepository } from ".";
import getEndpoint from "@/utils/domain";
import axios from "axios";
import { createHeader } from "@/utils/createHeader";

// export const ENDPOINT_PATH = getEndpoint("/api/calculatePrice");
export const ENDPOINT_PATH = "https://0hbymt9qbk.execute-api.ap-southeast-1.amazonaws.com/Prod"
// export const CALCULATE_COST_ENPOINT = getEndpoint("/calculatecost2/calculatecost2")
// const CALCULATE_COST_ENPOINT = "https://shop.villamarket.com/api/calculatecost2/calculatecost2"
export const CALCULATE_COST_ENPOINT = "https://m4q33ulvm9.execute-api.ap-southeast-1.amazonaws.com/Prod/calculatecost2"

export class CalculatePriceAPIRepository implements ICalculatePriceRepository {
    async getCost(input: Order, apikey: string): Promise<Order> {
        console.log("getCost input:", input, apikey);
        const response = (await axios.post(ENDPOINT_PATH + "/getCost", input, {
            headers: createHeader({ apikey, idToken: null }) as any,
            validateStatus: function (status) {
                return true;
            },
        })) as any;
        if (response.status == 200) {
            console.log({response});
            return new Order(response.data);
        } else {
            throw new Error("Failed to getCost");
        }
    }

    async suggestCoupon(input: Order, apikey: string): Promise<any> {
        console.log("suggestCoupon input:", input, apikey);
        const response = (await axios.post(ENDPOINT_PATH + "/suggestCoupon", input, {
            headers: createHeader({ apikey, idToken: null }) as any,
            validateStatus: function (status) {
                return true;
            },
        })) as any;
        if (response.status == 200) {
            console.log({response});
            return response.data;
            // return new Order(response.data);
        } else {
            throw new Error("Failed to suggestCoupon");
        }
    }

    // async getResolveCoupon(input: Order, apikey: string): Promise<Order> {
    //     console.log("getResolveCoupon input:", input, apikey);
    //     const response = (await axios.post(ENDPOINT_PATH + "/resolveCoupon", input, {
    //         headers: createHeader({ apikey, idToken: null }) as any,
    //         validateStatus: function (status) {
    //             return true;
    //         },
    //     })) as any;
    //     if (response.status == 200) {
    //         console.log({response});
    //         return new Order(response.data);
    //     } else {
    //         throw new Error("Failed to getResolveCoupon");
    //     }
    // }

    async getResolveCoupon(input: Order, apikey: string): Promise<Order> {
        console.log("getResolveCoupon input:", input, apikey);
        const response = (await axios.post(CALCULATE_COST_ENPOINT, input, {
            headers: createHeader({ apikey, idToken: null }) as any,
            validateStatus: function (status) {
                return true;
            },
        })) as any;
        if (response.status == 200) {
            console.log({response});
            return new Order(response.data);
        } else {
            throw new Error("Failed to getResolveCoupon");
        }
    }
}
